import { Button } from '@alchemer/ui/components/button';
import { Plus } from '@alchemer/ui/icons';
import { useRef } from 'react';
import { useOnClickOutside } from '@alchemer/ui/hooks/use-click-outside';
import { useIframeBlur } from '@/hooks/useIframeBlur';
import { useToggleState } from '@/hooks/useToggleState';
import { CreatePopover } from '../CreatePopover/CreatePopover';

export function CreateButton() {
  const createPopoverRef = useRef<HTMLDialogElement | null>(null);
  const createBtnRef = useRef<HTMLButtonElement | null>(null);
  const [isCreatePopoverOpen, toggleCreatePopover] = useToggleState(false);

  useOnClickOutside(createPopoverRef as React.RefObject<HTMLElement>, (event) => {
    if (!isCreatePopoverOpen) return;
    // Clicking the button should NOT trigger "outside" behavior
    if (createBtnRef.current?.contains(event.target as Node)) return;

    toggleCreatePopover();
  });

  useIframeBlur(isCreatePopoverOpen, toggleCreatePopover);

  return (
    <div className="relative">
      <Button
        size="sm"
        id="createBtn"
        ref={createBtnRef}
        aria-haspopup="dialog"
        className="h-7 cursor-pointer rounded-xs text-xs"
        onClick={toggleCreatePopover}
      >
        <Plus />
        Create
      </Button>
      <CreatePopover
        isVisible={isCreatePopoverOpen}
        toggleCallback={toggleCreatePopover}
        htmlRef={createPopoverRef}
      />
    </div>
  );
}
